export const REPORT_STATUSES = {
  CREATED: 'created',
  GENERATED: 'generated',
  FAILED: 'failed',
};
